// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$location._c.campaigns/route.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$location._c.campaigns/route.tsx");
}
// REMIX HMR END

import { campaignListExample } from '@commural/shared-resources/schemas/business/Campaign.example';
import { useLoaderDataWithCache } from '@commural/shared-resources/utils/common';
import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { Link, useSearchParams } from '@remix-run/react';
import { useCallback } from 'react';
import invariant from 'tiny-invariant';
import { z } from 'zod';
import { Pagination } from '~/components/Pagination';
import { ScrollView } from '~/components/ScrollView';
import { useFormattedDate } from '~/hooks/useFormattedDate';
import { getCapitalized } from '~/utils.server';
import { getPaginated } from '~/utils/getPaginated';
import cn from './Campaigns.module.css';
const TITLE = 'campaigns';
const PublishedFilterEnum = z.enum(['all', 'published', 'draft']);
export async function loader({
  request,
  context
}) {
  const title = await getCapitalized(TITLE, request, context);
  const url = new URL(request.url);
  const result = PublishedFilterEnum.safeParse(url.searchParams.get('published') ?? 'all');
  const publishedFilter = result.success ? result.data : 'all';
  const campaignList = campaignListExample.filter(el => {
    switch (publishedFilter) {
      case 'all':
        return true;
      case 'published':
        return !el.draft;
      case 'draft':
        return el.draft;
      default:
        return false;
    }
  });
  const {
    start,
    end,
    currentPage,
    pageCount
  } = getPaginated(url, campaignList.length);
  return {
    title,
    campaignList: campaignList.slice(start, end),
    currentPage,
    pageCount,
    publishedFilter
  };
}
export const meta = ({
  data
}) => {
  invariant(data?.title, 'title is required');
  return [{
    title: data.title
  }];
};
export const handle = {
  title: TITLE
};
export default function Index() {
  _s();
  const {
    campaignList,
    currentPage,
    pageCount,
    publishedFilter
  } = useLoaderDataWithCache();
  const {
    1: setSearchParams
  } = useSearchParams();
  const handleChangeFilter = useCallback(value => {
    setSearchParams({
      published: value
    }, {
      replace: true
    });
  }, [setSearchParams]);
  return <ScrollView>
      <section className={cn.Campaigns}>
        <header className={cn.Header}>
          <div>
            <ToggleGroup.Root className={cn.ToggleGroup} type="single" value={publishedFilter} onValueChange={handleChangeFilter}>

              <ToggleGroup.Item className={cn.ToggleGroupItem} value="all">
                all
              </ToggleGroup.Item>
              <ToggleGroup.Item className={cn.ToggleGroupItem} value="published">

                published
              </ToggleGroup.Item>
              <ToggleGroup.Item className={cn.ToggleGroupItem} value="draft">
                draft
              </ToggleGroup.Item>
            </ToggleGroup.Root>
          </div>
          <button className="debug-block">create campaign</button>
        </header>
        <main>
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Published Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {campaignList.map(el => <CampaignListItem key={el.id} campaign={el} />)}
            </tbody>
          </table>
        </main>
        <footer className={cn.Footer}>
          <Pagination currentPage={currentPage} pageCount={pageCount} additionalParams={{
          published: publishedFilter
        }} />

        </footer>
      </section>
    </ScrollView>;
}
_s(Index, "ao167Uk5vBlaqg4PkujZ67fUNjU=", false, function () {
  return [useLoaderDataWithCache, useSearchParams];
});
_c = Index;
function CampaignListItem({
  campaign
}) {
  _s2();
  const {
    id,
    name,
    draft
  } = campaign;
  const publishedAt = useFormattedDate(campaign.publishedAt);
  const status = draft ? 'draft' : 'published';
  return <tr>
      <td>
        <Link to={id}>{name}</Link>
      </td>
      <td>{publishedAt}</td>
      <td>{status}</td>
    </tr>;
}
_s2(CampaignListItem, "zS5k+nE1DjGNeEp9vOQR+TYjtbU=", false, function () {
  return [useFormattedDate];
});
_c2 = CampaignListItem;
var _c, _c2;
$RefreshReg$(_c, "Index");
$RefreshReg$(_c2, "CampaignListItem");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;